export const NETWORK_SLUGS = {
  roots: "roots",
  adw: "adw",
  klow: "klow",
} as const

export type NetworkSlug = (typeof NETWORK_SLUGS)[keyof typeof NETWORK_SLUGS]

type NetworkUser = {
  role?: string | null
  network_slugs?: string[] | null
} | null | undefined

export function userNetworkSlugs(user: NetworkUser): string[] {
  if (!user) return [NETWORK_SLUGS.roots]
  if (user.network_slugs && user.network_slugs.length > 0) {
    return user.network_slugs.map((slug) => slug.toLowerCase())
  }
  return [NETWORK_SLUGS.roots]
}

export function userHasNetwork(user: NetworkUser, slug: string): boolean {
  const normalized = slug.trim().toLowerCase()
  if (!normalized) return false
  return userNetworkSlugs(user).includes(normalized)
}

export function networkLabel(slug: string): string {
  switch (slug.toLowerCase()) {
    case NETWORK_SLUGS.roots:
      return "Roots"
    case NETWORK_SLUGS.adw:
      return "ADW"
    case NETWORK_SLUGS.klow:
      return "KLOW"
    default:
      return slug
  }
}
